module.exports = __webpack_public_path__ + "static/icon_color_medical-90c3fe5642bb8d9e8c00cb0ebbe1eff5.png";